import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent } from './ui/card';
import { Check, ChefHat, Heart, Leaf } from 'lucide-react';

export const About = () => {
  const navigate = useNavigate();
  
  const features = [
    {
      icon: ChefHat,
      title: 'Fait Maison',
      description: 'Pâte à pizza pétrie chaque jour sur place',
    },
    {
      icon: Leaf,
      title: 'Produits Frais',
      description: 'Légumes 100% frais livrés chaque matin par Lander\'Primeur',
    },
    {
      icon: Heart,
      title: 'Qualité Garantie',
      description: 'Steaks hachés pur bœuf d\'origine finistérienne',
    },
    {
      icon: Check,
      title: 'Pain Artisanal',
      description: 'Pain du boulanger préparé chaque matin par La Fleur du Pain',
    },
  ];

  return (
    <section id="about" className="py-16 sm:py-24 bg-gradient-subtle">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-foreground mb-4 sm:mb-6">
            Notre Engagement
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
            Depuis 2015, nous préparons avec passion des burgers et pizzas artisanaux
            en utilisant uniquement des ingrédients frais et locaux de qualité.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <Card
                key={index}
                className="border-border shadow-soft hover:shadow-medium transition-all duration-300 hover:-translate-y-1 bg-card"
              >
                <CardContent className="p-6">
                  <div className="flex flex-col items-center text-center space-y-4">
                    <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center">
                      <Icon className="w-8 h-8 text-primary" />
                    </div>
                    <h3 className="text-xl font-semibold text-foreground">
                      {feature.title}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">
                      {feature.description}
                    </p>
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Image Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 mt-16">
          <div 
            onClick={() => navigate('/galerie')}
            className="relative overflow-hidden rounded-lg shadow-medium group cursor-pointer"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/st5ssihp_Italienne.JPG"
              alt="Pizza artisanale - L'Italienne"
              className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-accent/80 to-transparent flex items-end p-6">
              <div>
                <h3 className="text-2xl font-bold text-background">Nos Pizzas</h3>
                <p className="text-sm text-background/80 mt-1">Voir la galerie →</p>
              </div>
            </div>
          </div>
          <div 
            onClick={() => navigate('/galerie')}
            className="relative overflow-hidden rounded-lg shadow-medium group cursor-pointer"
          >
            <img
              src="https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/t89eurfu_Italien.JPG"
              alt="Burger artisanal - L'Italien"
              className="w-full h-80 object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-accent/80 to-transparent flex items-end p-6">
              <div>
                <h3 className="text-2xl font-bold text-background">Nos Burgers</h3>
                <p className="text-sm text-background/80 mt-1">Voir la galerie →</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;